import { render, staticRenderFns } from "./WorkplaceConfigModal.vue?vue&type=template&id=62ea9afc"
import script from "./WorkplaceConfigModal.vue?vue&type=script&lang=js"
export * from "./WorkplaceConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports